export {default} from './LogoView'
